/* ============================================================
   Nutry PDP v2 — quantity ladder on one variant, gallery thumbs,
   add to cart through window.nutryAdd (nutry.js), sticky bar.
   ============================================================ */
(() => {
  "use strict";
  const $  = s => document.querySelector(s);
  const $$ = s => Array.from(document.querySelectorAll(s));
  const money = c => (c / 100).toLocaleString("en-US", { maximumFractionDigits: 0 }) + " EGP";

  /* ---------- ladder ---------- */
  let qty = 2, total = 0, label = "2 packs", setOf = "";
  const atc = $("#atc"), atcLabel = $("#atcLabel"), atcTotal = $("#atcTotal"), atcNote = $("#atcNote"), barMeta = $("#barMeta");
  const SHIP = (window.NUTRY || {}).ship || 0;
  const barName = $(".bar2-name"), baseName = barName ? barName.textContent.trim() : "";
  function select(btn) {
    if (!btn) return;
    qty = Number(btn.dataset.q); total = Number(btn.dataset.total); label = btn.dataset.label; setOf = btn.dataset.setOf || "";
    $$(".opt2").forEach(b => b.setAttribute("aria-pressed", String(b === btn)));
    if (atcTotal) atcTotal.textContent = money(total);
    if (atcNote) atcNote.textContent = `${label} · ${qty * 12} sachets · ${qty > 1 ? "free delivery" : "+ " + money(SHIP) + " delivery"}`;
    /* sticky bar: packs on the name line, price + delivery on the meta line, so nothing truncates next to "Add to cart" */
    if (barName) barName.textContent = `${baseName} · ${label}`;
    if (barMeta) barMeta.textContent = `${money(total)} · ${qty > 1 ? "free delivery" : "+ " + money(SHIP) + " delivery"}`;
  }
  const opts = $("#opts");
  if (opts) {
    opts.addEventListener("click", e => { const b = e.target.closest(".opt2"); if (b) select(b); });
    select($('.opt2[aria-pressed="true"]') || $(".opt2"));
  }

  /* ---------- add ---------- */
  let done;
  function add() {
    if (!atc || !window.nutryAdd) return;
    if (setOf && window.nutryAddMany) window.nutryAddMany(setOf.split(",").filter(Boolean));
    else window.nutryAdd(atc.dataset.variant, qty);
    atc.classList.add("done");
    if (atcLabel) atcLabel.textContent = "Added to cart";
    clearTimeout(done);
    done = setTimeout(() => { atc.classList.remove("done"); if (atcLabel) atcLabel.textContent = "Add to cart"; }, 1900);
  }
  if (atc) atc.addEventListener("click", add);
  const barBtn = $("#barBtn"); if (barBtn) barBtn.addEventListener("click", add);

  /* ---------- gallery thumbs ---------- */
  const track = $("#galTrack"), thumbs = $("#galThumbs");
  if (track && thumbs) {
    thumbs.addEventListener("click", e => {
      const b = e.target.closest("button"); if (!b) return;
      track.scrollTo({ left: Number(b.dataset.i) * track.clientWidth, behavior: "smooth" });
    });
    let t;
    track.addEventListener("scroll", () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const ix = Math.round(track.scrollLeft / track.clientWidth);
        $$("#galThumbs button").forEach(b => b.setAttribute("aria-selected", String(Number(b.dataset.i) === ix)));
      }, 80);
    }, { passive: true });
  }

  /* ---------- objection answers: one open at a time keeps the column short ---------- */
  const acc = $$("#ob3 details");
  acc.forEach(d => d.addEventListener("toggle", () => { if (d.open) acc.forEach(o => { if (o !== d) o.open = false; }); }));

  /* ---------- sticky bar: hidden only while the big CTA is on screen ---------- */
  const bar = $("#bar");
  if (bar && atc && "IntersectionObserver" in window) {
    new IntersectionObserver(([en]) => {
      bar.classList.toggle("hide", en.isIntersecting);
      bar.setAttribute("aria-hidden", String(en.isIntersecting));
      bar.toggleAttribute("inert", en.isIntersecting);
    }, { threshold: .6 }).observe(atc);
  }
})();
